// TODO: Можно объединить с sections/footer/index.js, components/contacts/index.js
const advantageMoreButtons = [...document.querySelectorAll('.j-advantages-more')];
const activeClass = 'is-active';

advantageMoreButtons.forEach((advantageMoreButton) => {
    advantageMoreButton.addEventListener('click', () => {
        advantageMoreButton.classList.toggle(activeClass);
        advantageMoreButton.previousElementSibling.classList.toggle(activeClass);
    });
});

